import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=e8c23a92&scoped=true"
import script from "./AppDetail.vue?vue&type=script&lang=ts"
export * from "./AppDetail.vue?vue&type=script&lang=ts"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=e8c23a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c23a92",
  null
  
)

export default component.exports